const getAllPerformanceMetrics = () => {
  if (typeof window === "undefined" || typeof window.performance === "undefined" || typeof window.performance.getEntriesByType !== "function") {
    return {};
  }
  const metrics = window.performance.getEntriesByType("mark").filter((item) => item.name.startsWith("pns_privacy_product_mark"));
  const measureMetrics = window.performance.getEntriesByType("measure").filter((item) => item.name.startsWith("pns_privacy_product_duration"));
  return [
    ...metrics,
    ...measureMetrics
  ].map((metric) => ({
    duration: metric.duration,
    entryType: metric.entryType,
    name: metric.name,
    startTime: metric.startTime
  })).reduce((prev, metric) => {
    {
      prev[metric.name] = metric.entryType === "mark" ? Math.floor(metric.startTime) : Math.floor(metric.duration);
      return prev;
    }
  }, {});
};
const getDCLTime = () => {
  if (typeof window === "undefined" || typeof window.performance === "undefined" || typeof window.performance.measure !== "function" || typeof window.performance.getEntriesByName !== "function") {
    return -1;
  }
  window.performance.measure("DCL", "fetchStart", "domContentLoadedEventEnd");
  const dclEntries = window.performance.getEntriesByName("DCL");
  if (dclEntries.length > 0) {
    return dclEntries[0].duration;
  }
  return -1;
};
const reportTTAPActualFMP = (slardarClient, duration) => {
  slardarClient("sendCustomPerfMetric", {
    name: "actual_fmp",
    value: duration
  });
};
const getOSFromUA = () => {
  var _navigator;
  let os = "unknown";
  var _navigator_userAgent;
  const ua = (_navigator_userAgent = (_navigator = navigator) === null || _navigator === void 0 ? void 0 : _navigator.userAgent) !== null && _navigator_userAgent !== void 0 ? _navigator_userAgent : "";
  if (/android|Android/i.test(ua)) {
    os = "Android";
  }
  if (/iPhone|iPad|iPod|iOS/i.test(ua)) {
    os = "iOS";
  }
  return {
    os,
    isAndroid: os === "Android",
    isIOS: os === "iOS"
  };
};
const sendRequest = (method, params) => {
  if (!params)
    return;
  const finalParams = {
    method,
    params
  };
  const isLynx = typeof NativeModules !== "undefined";
  if (isLynx) {
    var _NativeModules_hybridMonitor, _NativeModules;
    const lynxModule = (_NativeModules = NativeModules) === null || _NativeModules === void 0 ? void 0 : (_NativeModules_hybridMonitor = _NativeModules.hybridMonitor) === null || _NativeModules_hybridMonitor === void 0 ? void 0 : _NativeModules_hybridMonitor.request;
    lynxModule === null || lynxModule === void 0 ? void 0 : lynxModule(finalParams, () => {
    });
    return;
  }
  const os = getOSFromUA();
  if (os.isIOS) {
    var _window_webkit_messageHandlers_bdhmRequest_postMessage, _window_webkit_messageHandlers_bdhmRequest, _window_webkit_messageHandlers, _window_webkit, _window;
    (_window = window) === null || _window === void 0 ? void 0 : (_window_webkit = _window.webkit) === null || _window_webkit === void 0 ? void 0 : (_window_webkit_messageHandlers = _window_webkit.messageHandlers) === null || _window_webkit_messageHandlers === void 0 ? void 0 : (_window_webkit_messageHandlers_bdhmRequest = _window_webkit_messageHandlers.bdhmRequest) === null || _window_webkit_messageHandlers_bdhmRequest === void 0 ? void 0 : (_window_webkit_messageHandlers_bdhmRequest_postMessage = _window_webkit_messageHandlers_bdhmRequest.postMessage) === null || _window_webkit_messageHandlers_bdhmRequest_postMessage === void 0 ? void 0 : _window_webkit_messageHandlers_bdhmRequest_postMessage.call(_window_webkit_messageHandlers_bdhmRequest, finalParams);
  } else if (os.isAndroid) {
    var _window_iesJsBridgeTransferMonitor_request, _window_iesJsBridgeTransferMonitor, _window1;
    (_window1 = window) === null || _window1 === void 0 ? void 0 : (_window_iesJsBridgeTransferMonitor = _window1.iesJsBridgeTransferMonitor) === null || _window_iesJsBridgeTransferMonitor === void 0 ? void 0 : (_window_iesJsBridgeTransferMonitor_request = _window_iesJsBridgeTransferMonitor.request) === null || _window_iesJsBridgeTransferMonitor_request === void 0 ? void 0 : _window_iesJsBridgeTransferMonitor_request.call(_window_iesJsBridgeTransferMonitor, JSON.stringify(finalParams));
  }
};
const sparkMark = (key, value, description) => {
  const params = {
    key,
    value: value === void 0 ? Date.now() : value,
    description: description || ""
  };
  sendRequest("timing.mark", params);
};
const getURLQueryValue = (key, fallbackValue = "") => {
  if (typeof location === "undefined" || typeof URLSearchParams === "undefined") {
    return "";
  }
  const params = new URLSearchParams(location.search);
  return params.get(key) || fallbackValue;
};
const getCommonParams = () => {
  var _window_gfdatav1, _window_gfdatav11;
  var _window_gfdatav1_ver, _window_gfdatav1_canary;
  return {
    scm_version: typeof window === "undefined" ? "" : (_window_gfdatav1_ver = (_window_gfdatav1 = window.gfdatav1) === null || _window_gfdatav1 === void 0 ? void 0 : _window_gfdatav1.ver) !== null && _window_gfdatav1_ver !== void 0 ? _window_gfdatav1_ver : "",
    path: typeof location === "undefined" ? "" : location.pathname,
    enter_from: getURLQueryValue("enter_from"),
    host: typeof location === "undefined" ? "" : location.host,
    canary: typeof window === "undefined" ? "" : (_window_gfdatav1_canary = (_window_gfdatav11 = window.gfdatav1) === null || _window_gfdatav11 === void 0 ? void 0 : _window_gfdatav11.canary) !== null && _window_gfdatav1_canary !== void 0 ? _window_gfdatav1_canary : ""
  };
};
export {
  getAllPerformanceMetrics,
  getCommonParams,
  getDCLTime,
  getOSFromUA,
  getURLQueryValue,
  reportTTAPActualFMP,
  sendRequest,
  sparkMark
};
